import { useEffect } from 'react';

export const useClickOn = (ref, func) => {
  useEffect(() => {
    const handleOnClick = (event) => {
      if (ref.current?.contains(event.target)) {
        func();
      }
    };

    // Bind the click outside event listener
    document.addEventListener('mousedown', handleOnClick);

    return () => document.removeEventListener('mousedown', handleOnClick);
  });
};
